"use client";

import React from "react";
import Link from "next/link";
import { getIcon } from "@litonarefin/utils/icons";
import { getStyledIcon } from "@litonarefin/utils/getStyledIcon";
import { cn } from "@litonarefin/utils";

const BreadcrumbList = ({ name, slug = "", position, icon = "arrow", last = false }) => {
  return (
    <li>
      <Link
        prefetch={false}
        href={last ? "#" : slug}
        className={cn(
          "jlt-flex jlt-items-center jlt-gap-1",
          last ? "jlt-cursor-default jlt-pointer-events-none" : ""
        )}
        aria-label={name || "Home page"}
      >
        {icon === "arrow"
          ? getStyledIcon(getIcon("arrowRightAlt"), "#475467", undefined, {
              width: "8px",
              height: "8px",
            })
          : getStyledIcon(getIcon("home"), "#475467", "stroke", {
              width: "14px",
              height: "14px",
            })}
        <span
          className={cn(
            "jlt-text-[8px] md:jlt-text-[10px] jlt-font-medium jlt-text-[#667085] hover:jlt-text-[--primary] hover:jlt-underline"
          )}
          dangerouslySetInnerHTML={{ __html: name }}
        />
      </Link>
    </li>
  );
};

export default BreadcrumbList;
